import {
  EMAIL_RECIPIENT_TYPE,
  EmailRecipient,
} from "#customTypes/composedTypes/emailTypes"
import { StudentConstructor } from "#customTypes/composedTypes/studentTypes"

const STUDENT_CONTACT_FIELDS = [
  // { email: "personalEmail", name: "name" },
  { email: "guardian1Email", name: "guardian1Name" },
  { email: "guardian2Email", name: "guardian2Name" },
] as const

/** True for form/doc keys that store email addresses (`email`, `personalEmail`, …). */
export const isEmailFieldKey = (key: string): boolean => {
  if (!key) return false
  return key === "email" || key.endsWith("Email")
}

/** Trim + lowercase. Empty/non-string → `""` (matches server `normalizeEmail`). */
export const normalizeEmail = (email: unknown): string => {
  if (typeof email !== "string") return ""
  return email.trim().toLowerCase()
}

/**
 * AntD Form.Item `normalize` — lowercases as the user types.
 * Does not trim (trimming mid-edit fights whitespace); `cleanFormData` trims on submit.
 */
export const normalizeEmailFormValue = (value: unknown): unknown => {
  if (typeof value !== "string") return value
  return value.toLowerCase()
}

export const getStudentRecipients = (
  student: StudentConstructor,
  type: EMAIL_RECIPIENT_TYPE = EMAIL_RECIPIENT_TYPE.TO
) => {
  const recipients: EmailRecipient[] = []

  STUDENT_CONTACT_FIELDS.forEach(({ email, name }) => {
    const recipientEmail = student[email]
    const recipientName = student[name]

    if (recipientEmail) {
      recipients.push({
        name: recipientName ?? "",
        email: recipientEmail,
        type,
      })
    }
  })

  return recipients
}
